import { apiClient } from "../../base/ApiClient";

export const createVisit = async (formData) => {
  const response = await apiClient.post(`/client/visits/`, formData);
  return response;
};

export const getVisitByClientID = async (clientID, visit_type) => {
  const params = new URLSearchParams();
  if (clientID) params.append("client_id", clientID);
  if (visit_type) params.append("visit_type", visit_type);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(`/client/visits/${queryString}`);
  return response.data;
};

export const getVisitByID = async (ID) => {
  const response = await apiClient.get(`/client/visits/${ID}/`);
  return response.data;
};

export const updateVisit = async (ID, formData) => {
  return await apiClient.put(`/client/visits/${ID}/`, formData);
};

export const deleteVisitByID = async (ID) => {
  const response = await apiClient.delete(`/client/visits/${ID}/`);
  return response.data;
};

export const getLocations = async () => {
  const response = await apiClient.get(`/core/location/`);
  return response.data;
};

export const getSubLocations = async (id, date) => {
  const response = await apiClient.get(
    `/schedule/${id}/sublocations/?date=${date ? date : ""}`
  );
  return response.data;
};

export const getTemplate = async (sublocation) => {
  const response = await apiClient.get(
    `/schedule/templates/?sublocation=${sublocation}`
  );
  return response.data;
};

export const createTemplate = async (formData) => {
  const response = await apiClient.post(`/schedule/templates/`, formData);
  return response;
};

export const getRuns = async (id, run_type) => {
  const params = new URLSearchParams();
  if (id) params.append("template_id", id);
  if (run_type) params.append("run_type", run_type);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(`/schedule/runs/${queryString}`);
  return response.data;
};

export const createRuns = async (formData) => {
  const response = await apiClient.post(`/schedule/runs/`, formData);
  return response;
};

export const getRunsByArea = async (area) => {
  const params = new URLSearchParams();
  if (area) params.append("area", area);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(`/schedule/runs/area${queryString}`);
  return response.data;
};

export const getUnAssignedVisits = async (area) => {
  const params = new URLSearchParams();
  if (area) params.append("area", area);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(
    `/schedule/visits/unassigned/${queryString}`
  );
  return response.data;
};

export const updateVisits = async (id, data, type) => {
  const params = new URLSearchParams();
  if (type) params.append("type", type);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.patch(
    `/schedule/visits/update/${id}/${queryString}`,
    data
  );
  return response;
};

export const getVisitsByRun = async (id) => {
  const response = await apiClient.get(`/schedule/visits/run/${id}/`);
  return response;
};

export const getScheduleJobByVisit = async (id) => {
  const response = await apiClient.get(`/schedule/schedule-jobs/${id}`);
  return response.data;
};

export const getScheduleJobDetails = async (id) => {
  const response = await apiClient.get(`/schedule/job-details/${id}/`);
  return response.data;
};

export const deleteScheduleJob = async (id) => {
  const response = await apiClient.delete(`/schedule/schedule-jobs/${id}/`);
  return response;
};

export const getCandidates = async (workPermit = false, location, start_time, end_time, area) => {
  const params = new URLSearchParams();
  if (location) params.append("location", location);
  if (start_time) params.append("start_time", start_time);
  if (end_time) params.append("end_time", end_time);
  if (area) params.append("area", area);
  if (workPermit) params.append("work_permit", "true");
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(`/schedule/candidates/${queryString}`);
  return response.data;
};

export const getCandidatesByArea = async (area, search, assignmentId, isScheduleJob = false) => {
  const params = new URLSearchParams();
  if (area) params.append("area", area);
  if (search) params.append("search", search);
  if (assignmentId) params.append("assignment", assignmentId);
  if (isScheduleJob) params.append("is_schedule_job", "true");
  
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(`/schedule/candidates/${queryString}`);
  return response.data;
};

export const checkCandidateConflict = async (data) => {
  const response = await apiClient.post(
    `/schedule/candidates/check-conflict/`,
    data
  );
  return response.data;
};

export const getCandidateWeeklyHistory = async (candidate_id) => {
  const response = await apiClient.get(
    `/schedule/candidate/schedule-history/${candidate_id}`
  );
  return response.data;
};

export const createBuildTemplate = async (formData) => {
  const response = await apiClient.post(`/schedule/build/`, formData);
  return response;
};

export const getBuildHistory = async (date, location_id) => {
  const response = await apiClient.get(
    `/schedule/build-history/?date=${date}&location_id=${location_id}`
  );
  return response.data;
};

export const updateScheduleJob = async (id, data) => {
  const response = await apiClient.patch(
    `/schedule/schedule-job/update/${id}/`,
    data
  );
  return response;
};

export const getScheduledRunVisits = async (date, sublocation_id, run_type) => {
  const params = new URLSearchParams();
  if (date) params.append("date", date);
  if (sublocation_id) params.append("sublocation_id", sublocation_id);
  if (run_type) params.append("run_type", run_type);
  const response = await apiClient.get(
    `/schedule/schedule-jobs/?${params.toString()}`
  );
  return response.data;
};

export const getWeeklyAssignmentByVisit = async (visit_id) => {
  const response = await apiClient.get(`/schedule/assignment/${visit_id}`);
  return response.data;
};

export const updateWeeklyAssignment = async (data, id) => {
  const response = await apiClient.patch(
    `/schedule/assignment/update/${id}`,
    data
  );
  return response;
};

export const getAssignmentDetails = async (id) => {
  const response = await apiClient.get(`/schedule/assignment/details/${id}`);
  return response.data;
};

export const getPreviousBuildHistory = async (date, sublocation_id) => {
  const params = new URLSearchParams();
  if (date) params.append("date", date);
  if (sublocation_id) params.append("sublocation_id", sublocation_id);
  const response = await apiClient.get(
    `/schedule/previous-build-history/?${params.toString()}`
  );
  return response.data;
};

export const updateRunInScheduleJobs = async (visit_id, data) => {
  const response = await apiClient.patch(
    `/schedule/schedule-jobs/update/${visit_id}/`,
    data
  );
  return response;
};

export const addEmployeeInScheduleJobs = async (data, job_id) => {
  const response = await apiClient.patch(
    `/schedule/schedule-jobs/${job_id}/add-employees/`,
    data
  );
  return response;
};

export const getScheduleTaskDetails = async (job_id) => {
  const response = await apiClient.get(
    `/schedule/schedule-jobs/task-details/${job_id}`
  );
  return response.data;
};

export const confirmScheduleJob = async (job_id, data) => {
  const response = await apiClient.post(
    `/schedule/confirm-job/${job_id}`,
    data
  );
  return response;
};

export const getScheduleJobByStatus = async (page, status, location_id) => {
  const params = new URLSearchParams();
  if (status) params.append("status", status);
  if (page) params.append("page", page);
  if (location_id) params.append("location_id", location_id);
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const response = await apiClient.get(
    `/schedule/schedule-jobs/status/${queryString}`
  );
  return response.data;
};

export const getScheduleJobNeedAttention = async (page) => {
  const response = await apiClient.get(
    `/schedule/schedule-jobs/need-attention/?page=${page}`
  );
  return response.data;
};

export const getDailyScheduleJobs = async (page, date) => {
  const response = await apiClient.get(
    `/schedule/schedule-jobs/daily/?page=${page}&date=${date}`
  );
  return response.data;
};

export const unassignEmployees = async (payload) => {
  const response = await apiClient.post(`/schedule/scheduled/employee-assignments/unassign/`, payload);
  return response;
};

export const assignEmployees = async (payload) => {
  const response = await apiClient.post(`/schedule/scheduled/employee-assignments/assign/`, payload);
  return response;
};

export const replaceEmployees = async (payload) => {
  const response = await apiClient.post(`/schedule/scheduled/employee-assignments/replace/`, payload);
  return response;
};

export const getPendingJobs = async (assignmentId) => {
  const response = await apiClient.get(`/schedule/assignment/${assignmentId}/pending-jobs/`);
  return response.data;
};